import { GET_DOCUMENT_COMMENTS_BY_DOCUMENTID,GET_DOCUMENT_COMMENTS_BY_DOCUMENTID_ERROR,
    POST_DOCUMENT_COMMENTS_BY_DOCUMENTID,POST_DOCUMENT_COMMENTS_BY_DOCUMENTID_ERROR,
    POST_PROGRESS_COMMENTS,POST_PROGRESS_COMMENTS_ERROR,GET_PROGRESS_COMMENTS,GET_PROGRESS_COMMENTS_ERROR} from '../type'
import axios from 'axios';
import env from '../../ENV';
let ROOT_URL = env.BACKEND_URL;

export const GenericGetCommentsbyDocumentID = (PoId,PoLineItemId,DocumentId,rowDocumentTypeId,rowDrawingDocumentDetailId = 0) => async dispatch => {
    let DrawingDocumentDetailId = rowDrawingDocumentDetailId ? rowDrawingDocumentDetailId : 0
    console.log(DrawingDocumentDetailId, 'rowDrawingDocumentDetailId')
    try{
        const res = await axios({
            method: 'get',
            url:`${ROOT_URL}document-comment/all/${PoId}/${PoLineItemId}/${DocumentId}/${rowDocumentTypeId}/${DrawingDocumentDetailId}`,
        })
        console.log(res,"Response")
        dispatch( {
            type: GET_DOCUMENT_COMMENTS_BY_DOCUMENTID,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_DOCUMENT_COMMENTS_BY_DOCUMENTID_ERROR,
            payload: console.log(e),
        })
    }

}

export const GenericPostCommentsbyDocumentID = (input) => async dispatch => {

        console.log("recieved in store ", input)
        try{
            const res = await axios({
                method: 'post',
                url: `${ROOT_URL}document-comment/add`,
                data: input,
                headers: {
                    'content-type': 'application/json',
                }
            })
            dispatch( {
                type: POST_DOCUMENT_COMMENTS_BY_DOCUMENTID,
                payload: res.data
            })
        }
        catch(e){
            dispatch( {
                type: POST_DOCUMENT_COMMENTS_BY_DOCUMENTID_ERROR,
                payload: console.log(e),
            })
        }
    
    }
    

export const postProgressComments = (input) => async dispatch => {

        console.log("recieved in store ", input)
        try{
            const res = await axios({
                method: 'post',
                url: `${ROOT_URL}progress-comment/add`,
                data: input,
                headers: {
                    'content-type': 'application/json',
                }
            })
            dispatch( {
                type: POST_PROGRESS_COMMENTS,
                payload: res.data
            })
        }
        catch(e){
            dispatch( {
                type: POST_PROGRESS_COMMENTS_ERROR,
                payload: console.log(e),
            })
        }
    
    }
    export const GetProgressComments = (PoId,PoLineItemId,DocumentTypeId) => async dispatch => {
        try{
            const res = await axios({
                method: 'get',
                url:`${ROOT_URL}${PoId}/${PoLineItemId}/${DocumentTypeId}/get-progress-comment`,
            })
            dispatch( {
                type: GET_PROGRESS_COMMENTS,
                payload: res.data
            })
        }
        catch(e){
            dispatch( {
                type: GET_PROGRESS_COMMENTS_ERROR,
                payload: console.log(e),
            })
        }
    
    }